export enum ServiceType {
  IN_GROUND = 'in-ground',
  MAUSOLEUM = 'mausoleum',
}

export const ServiceTypeLabel: Record<ServiceType, string> = {
  [ServiceType.IN_GROUND]: 'In-ground',
  [ServiceType.MAUSOLEUM]: 'Mausoleum',
};

export enum ServicePlace {
  MAUSOLEUM = 'mausoleum',
  SECTION = 'section',
}

export const ServicePlaceLabel: Record<ServicePlace, string> = {
  [ServicePlace.MAUSOLEUM]: 'Mausoleum',
  [ServicePlace.SECTION]: 'Section',
};
